import { Injectable, inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RouteHandlerService {
  private router = inject(Router);
  private lastAuthenticatedRoute: string | null = null;

  constructor() {
    // Suscribirse a los cambios de navegación para guardar la última ruta autenticada
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if (event.url && !event.url.includes('/login')) {
          this.lastAuthenticatedRoute = event.url;
          // Guardar la ruta en sessionStorage para persistir durante la sesión
          sessionStorage.setItem('lastAuthenticatedRoute', event.url);
        }
      });
  }

  // Obtener la última ruta autenticada
  getLastAuthenticatedRoute(): string | null {
    return this.lastAuthenticatedRoute || sessionStorage.getItem('lastAuthenticatedRoute');
  }

  // Navegar a la última ruta autenticada o a una ruta por defecto
  navigateToLastRoute(isAuthenticated: boolean, defaultRoute: string = '/wapi/home'): void {
    const lastRoute = this.getLastAuthenticatedRoute();
    if (lastRoute && isAuthenticated) {
      this.router.navigateByUrl(lastRoute);
    } else {
      this.router.navigateByUrl(defaultRoute);
    }
  }

  // Limpiar la ruta guardada (útil al hacer logout)
  clearLastRoute(): void {
    this.lastAuthenticatedRoute = null;
    sessionStorage.removeItem('lastAuthenticatedRoute');
  }

  // Verificar si la ruta actual requiere autenticación
  isProtectedRoute(url: string): boolean {
    return !url.includes('/login') && !url.includes('/public');
  }

  // Manejar la navegación después de una autenticación exitosa
  handleSuccessfulAuth(): void {
    const lastRoute = this.getLastAuthenticatedRoute();
    if (lastRoute) {
      this.router.navigateByUrl(lastRoute);
    } else {
      this.router.navigateByUrl('/wapi/home');
    }
  }
}
